import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h3>404</h3>
            <h4>Page not found on the server</h4>
        </div>
    );
};

export default NotFound;